
    import { mapState } from 'vuex';
    import C1Dropdown from '@/C1Components/C1Dropdown';

    export default {
        name: 'SearchDropdownAttributes',

        components: {
            C1Dropdown,
        },

        props: {
            attributeCode: {
                type: String,
                required: true,
            },

            options: {
                type: Array,
                required: true,
                default: () => [],
            },

            label: {
                type: String,
                default: '',
            },

            labelKey: {
                type: String,
                default: 'value',
            },

            valueKey: {
                type: String,
                default: 'value',
            },

            placeholder: {
                type: String,
                default: '',
            },

            defaultValue: {
                type: Object,
                default: () => {},
            },
        },

        computed: {
            ...mapState({
                $_search: state => state.search,
            }),

            attributeOptionsSelected: {
                get() {
                    let attributeOptionsSelected = this.defaultValue;
                    if (this.$_search.searchPayload?.search_filters) {
                        const searchAttribute = this.$_search.searchPayload.search_filters[this.attributeCode] || [];
                        if (searchAttribute && searchAttribute[this.valueKey]) {
                            attributeOptionsSelected = this.$_search.searchPayload.search_filters[this.attributeCode];
                        }
                    }
                    return attributeOptionsSelected;
                },
                set(attributeOptions) {
                    this.$store.commit('search/SET_SEARCH_FILTERS', { key: this.attributeCode, value: attributeOptions });
                },
            },
        },

        methods: {
            onChange() {
                this.$emit('change');
            },
        },
    };
